<template>
    <!-- Handmade Badge -->
    <v-chip class="white--text custom-chip mx-1 my-1" size="large" :color="label.color != '' ? label.color : '#e88be9'"
        variant="flat" label>
        <CustomIcon :fileType="'svg'" :type="label.name.includes('Made in') ? 'cities' : 'labels'"
            :iconName="label.name.includes('Made in') ? `${label.name.slice(8, label.name.length)}` : labelType">
        </CustomIcon>
        {{ label.translations[selectedLanguage.toUpperCase()].value }}
    </v-chip>
</template>

<script>
import CustomIcon from './CustomIcon.vue';
export default {
    components: {
        CustomIcon
    },
    setup() {
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        return {
            selectedLanguage
        }
    },

    computed: {
        labelType() {
            // Dynamically generate the path for the icon
            var name = this.label.name;
            switch (name) {
                case "Handgemacht":
                    return `labelIconProduction`
                case "Nachhaltig":
                    return `labelIconNature`
            }
            return `labelIconPeople`

        },
        labelColor() {
            var name = this.label.name;
            switch (name) {
                case "Handgemacht":
                    return `labelIconProduction`
                case "Nachhaltig":
                    return `labelIconNature`
            }
            return `labelIconPeople`
        }
    },

    props: {
        label: {
            type: Object,
            required: true,
        }
    },
    name: "CustomProductLabel",
};
</script>

<style scoped>
.custom-chip {
    font-weight: bold;
    /* Make text bold */
    padding: 0 12px;
    color: white !important;
    /* Adjust padding for better spacing */
}
</style>